import { useCallback } from 'react';
import { fromPairs, toPairs } from 'ramda';
import { deferUntilNewTitle } from '../../lib/deferUntilNewTitle';
import { tc } from '../../lib/trackingContext';
import { useCartItems } from '../useCart';

export const useOrderConvertedTracking = () => {
  const { cartItems } = useCartItems();

  const trackOrderConverted = useCallback(
    result => {
      const sessionParameters = JSON.parse(
        window?.sessionStorage.getItem('sessionQueryParams') ?? '{}'
      );
      // This is to coerce the keys to lowercase, because query params are case insensitive.
      const referralParameters = fromPairs(
        toPairs(sessionParameters).map(entry => [entry[0].toLowerCase(), entry[1]])
      );

      deferUntilNewTitle(() => {
        tc.track('Order Converted', {
          addToScopeOnce: {
            order: result.checkout.data[0],
            products: cartItems,
            referralParameters
          }
        });
      });
    },
    [cartItems]
  );

  return { trackOrderConverted };
};
